import { createSlice } from "@reduxjs/toolkit";
import { getTreatment, submitTreatment, deleteTreatment, deletePhotos } from "./Utils/treatmentUtils";
import Swal from 'sweetalert2';

const initialState = {
    filters: {
        "filter[id]": "",
        "filter[name]": "",
        "sort": "-id",
        "page": "",
        "include": "category",
    },
    treatments: [],
    pagination: {},
    loading: false,
    error: null,
    currentTreatment: {  // Ini buat menyimpan data form yang lagi aktif
        id: null,
        name: "",
        description: "",
        price: "",
        gimmick_price: "",
        benefits: "",
        process: "",
        category_id: "",
        photos: [],
    }
};


const treatmentSlice = createSlice({
    name: "treatment",
    initialState,
    reducers: {
        setFormData: (state, action) => {
            state.currentTreatment = { ...state.currentTreatment, ...action.payload };
        },
        resetFormData: (state) => {
            state.currentTreatment = initialState.currentTreatment;
        },
        setFilters: (state, action) => {
            state.filters = { ...state.filters, ...action.payload };
        }
    },
    extraReducers: (builder) => {
        builder
            // Handle getTreatment
            .addCase(getTreatment.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getTreatment.fulfilled, (state, action) => {
                state.loading = false;
                state.treatments = action.payload.data;
                state.pagination = action.payload.pagination;
            })
            .addCase(getTreatment.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Handle submitTreatment (update atau tambah treatment)
            .addCase(submitTreatment.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(submitTreatment.fulfilled, (state, action) => {
                state.loading = false;
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Data Layanan Perawatan Berhasil Disimpan',
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });

                // Kalau data baru, tambah ke daftar
                if (!state.treatments.find(treatment => treatment.id === action.payload.id)) {
                    state.treatments.push(action.payload);
                } else {
                    // Kalau update, replace data lama
                    state.treatments = state.treatments.map(treatment =>
                        treatment.id === action.payload.id ? action.payload : treatment
                    );
                }

                // Reset form setelah simpan
                state.currentTreatment = initialState.currentTreatment;
            })
            .addCase(submitTreatment.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Handle deleteTreatment
            .addCase(deleteTreatment.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteTreatment.fulfilled, (state, action) => {
                state.loading = false;
                state.treatments = state.treatments.filter(treatment => treatment.id !== action.payload.id);
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Data Layanan Perawatan Berhasil Dihapus',
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });
            })
            .addCase(deleteTreatment.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Handle deletePhotos
            .addCase(deletePhotos.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deletePhotos.fulfilled, (state, action) => {
                state.loading = false;
                state.currentTreatment.photos = state.currentTreatment.photos.filter(photo => photo.pivot.id !== action.payload.id);
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Data Berhasil Dihapus',
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });
            })
            .addCase(deletePhotos.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { setFormData, resetFormData, setFilters } = treatmentSlice.actions;
export default treatmentSlice.reducer;